const routes = [
  {
    path: "/notification_settings",
    component: () => import(/* webpackChunkName: "NotificationSettings" */ "./views/NotificationSettings"),
    props: route => ({
      activeCategory: route.query.activeCategory,
      origin: route.query.origin,
    }),
  },
];
export default routes;
